<script> 
	// The params prop contains values matched from the URL
	export let params = {};

	import {push, replace} from 'svelte-spa-router';
	import {createEventDispatcher, onMount} from 'svelte';
	import TBoxInterno from '../templates/TBoxInterno.svelte';
	import {
		API,
		cabecalhoPadraoRequisicao,
		dadosUsuarioLS,
		formatarCPF,
		parseJWT,
		removerObjeto,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		TipoPerfil
	} from '../../utils';
	import {sTituloPaginaAtual} from '../../stores';
    import BarraOperacoesRegistroVertical from '../../componentes/BarraOperacoesRegistroVertical.svelte';

	const dispatch = createEventDispatcher();
	let tituloAviso = "Erro";
	let usuario = {};
	let cpfFormatado;
	let usuarioToken = {};
	let anexos = [];
	let perfisDoUsuario = "";

	let menuOpcoes = [{
		titulo: 'Painel',
		cor: 'is-black is-outlined',
		callback: () => push('#/painel')
	}];

	async function validarEmailManualmente(idUsuarioAlvo) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Executando ...',
		});

		const resposta = await fetch(API('usuarios/validar-email-manualmente'), {
			method: 'PATCH',
			headers: cabecalhoPadraoRequisicao(),
			body: JSON.stringify({
				alvo: idUsuarioAlvo
			})
		}).catch(erros => {
			console.log(erros);

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});
		});

		const retorno = await resposta.json();

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
		
		dispatch('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: 'Aviso',
			conteudo: retorno?.mensagem
		});

		push('#/usuario/listagem');
	}

	async function bloquearOuDesbloquear(idUsuarioAlvo, objetivoOperacao) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Executando ...',
		});

		const resposta = await fetch(API('usuarios/bloquear-desbloquear'), {
			method: 'PATCH',
			headers: cabecalhoPadraoRequisicao(),
			body: JSON.stringify({
				alvo: idUsuarioAlvo,
				objetivo: objetivoOperacao
			})
		}).catch(erros => {
			console.log(erros);

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});
		});

		const retorno = await resposta.json();

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
		
		dispatch('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: 'Aviso',
			conteudo: retorno?.mensagem
		});

		push('#/painel/usuarios');
	};

	onMount(async () => {
		$sTituloPaginaAtual = `Visualização de Usuário (CPF: ${params.cpf})`;
		
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando usuário ...',
		});
		
		usuarioToken = dadosUsuarioLS();

		const resposta = await fetch(API(`usuarios/${params.cpf}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			console.log(erros);

			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const { dados } = await resposta.json();

		if (resposta.status == StatusHttp.OK) {
			usuario = dados;
			cpfFormatado = formatarCPF(usuario.cpf);
			anexos = [... usuario.anexos];
			perfisDoUsuario = usuario.perfis.split(",").join(" / ");
		} else {
			replace('#/usuario-inexistente');
		}

		// permitir apenas atualizar o próprio cadastro (admin pode atualizar cadastro de outros usuários)
		if (usuarioToken.cpf == usuario.cpf) {
			menuOpcoes.push({
				titulo: 'Atualizar',
				callback: () => push(`#/usuario/atualizacao/${params.cpf}`)
			}, {
				titulo: '+ Anexo',
				callback: () => push(`#/usuario/anexos/adicionar/${params.cpf}`)
			});
		}

		// se o usuário for admin adiciona opção de bloqueio/desbloqueio
		if (usuarioToken.admin == true) {
			menuOpcoes.push({
				titulo: usuario.bloqueado ? 'Desbloquear' : 'Bloquear',
				cor: usuario.bloqueado ? 'is-success' : 'is-danger',
				callback: () => usuario.bloqueado ? bloquearOuDesbloquear(usuario.id, 'DESBLOQUEAR') : bloquearOuDesbloquear(usuario.id, 'BLOQUEAR')
			});
		}

		if (usuarioToken.perfil == TipoPerfil.CETREINA) {
			menuOpcoes.push({
				titulo: 'Val. e-mail',
				cor: 'is-black',
				callback: () => usuario.email_verificado ? alert("Já está verificado") : validarEmailManualmente(usuario.id)
			}, {
				titulo: 'Gerenciar perfis',
				cor: 'is-black',
				callback: () => push(`#/usuario/perfil/atualizacao/${usuario.cpf}/${usuario.id}/${window.btoa(usuario.perfis)}`)
			}, {
				titulo: 'Projetos',
				cor: 'is-black',
				callback: () => push(`#/usuario/listagem/projetos/${usuario.cpf}`)
			}, {
				titulo: 'Distribuições',
				cor: 'is-black',
				callback: () => push(`#/usuario/listagem/distribuicoes/${usuario.cpf}`)
			}, {
				titulo: 'Avaliações',
				cor: 'is-black',
				callback: () => push(`#/usuario/listagem/avaliacoes/${usuario.cpf}`)
			});

			// se usuario alvo da operação também é funcionário (funcionário só pode ter um único perfil = CETREINA)
			if (usuario.perfis == "CETREINA" && usuarioToken.admin == true) {
				menuOpcoes.push({
					titulo: 'Config. Admin',
					cor: 'is-primary',
					callback: () => push(`#/usuario/cadastro/configurar-acesso-admin/${usuario.cpf}`)
				});
			}
		}

		menuOpcoes = [... menuOpcoes];

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	});
	
	const removerAnexo = async (idAnexo) => removerObjeto(idAnexo, dispatch, push, '#/painel/usuarios', 'usuarios/anexos');
	let tokenJWT = parseJWT(sessionStorage.getItem('AVAL_TOKEN'));
	let dataExpiracaoToken = new Date(parseInt(tokenJWT.exp) * 1000).toLocaleString()
</script>

<TBoxInterno 
	titulo={usuario.nome} 
	subtitulo="{perfisDoUsuario} &bull; {usuario.unidade} &bull; (CPF: {cpfFormatado})"
	largura="10" 
	icone="usuario"
	deslocamento="1">
	
	<div class="columns">
		<div class="column is-8">
			<p class="is-size-4 mb-3">Detalhes</p>
			<div class="permitir-selecao">
				<p>Matrícula: <strong>{usuario.matricula}</strong></p>
				<p>Unidade: <strong>{usuario.unidade}</strong></p>
				<p>E-mail: <strong>{usuario.email}</strong></p>
				<p>Área de interesse: <strong>{usuario.area_interesse}</strong></p>
			</div>

			{#if usuarioToken.perfil == TipoPerfil.CETREINA}
			<small>- - -</small>

			<p>E-mail verificado?: <strong>{usuario.email_verificado == true ? 'SIM' : 'NÃO'}</strong></p>
			<p>Precisa criar nova senha?: <strong>{usuario.precisa_criar_nova_senha == true ? 'SIM' : 'NÃO'}</strong></p>
			<p>Está bloqueado?: <strong>{usuario.bloqueado == true ? 'SIM' : 'NÃO'}</strong></p>
			<p>Requisições (API): <strong>{usuario.acessos}</strong></p>
			<p class="has-text-primary">Administrador do sistema?: <strong>{usuario.admin == true ? 'SIM' : 'NÃO'}</strong></p>
			<p><strong><a href="#/acesso/senha/provisoria/{usuario.cpf}/{usuario.id}">Clique aqui para gerar uma nova a senha provisória</a></strong></p>
			<small>- - -</small>
			{/if}

			<p>Data cadastro: <strong>{usuario.data_criacao}</strong></p>
			<p>Última atualização: <strong>{usuario.data_ultima_atualizacao}</strong></p>

			{#if usuario.email == tokenJWT.email}
			<br>
			<div class="notification is-danger is-light">
				<strong>Expiração do seu token de acesso: { dataExpiracaoToken }</strong>
				<br>
				<small>Para gerar novo token de acesso, basta sair e realizar login novamente!</small>
			</div>
			{/if}
		</div>

		<div class="column" style="border-left:1px dashed #aaa">
			<p class="is-size-4 mb-3">Operações:</p>
			<BarraOperacoesRegistroVertical opcoes={menuOpcoes} />
		</div>
	</div>

	{#if anexos?.length > 0}
	<p class="is-size-4 mb-4">Anexos</p>

	<table class="table is-fullwidth is-hoverable permitir-selecao">
		<thead>
			<tr>
				<th>Tipo</th>
				<th>Valor</th>
				<th title="Operações disponíveis" class="has-text-right">Operações</th>
			</tr>
		</thead>
		<tbody>
			{#each anexos as anexo}
			<tr>
				<td>{ anexo.tipo }</td>
				<td>{ anexo.valor }</td>
				<td title="Excluir" class="has-text-right"><button on:click={removerAnexo(anexo.id)} class="button is-danger is-small">Excluir</button></td>
			</tr>
			{/each}
		</tbody>
	</table>
	{/if}
</TBoxInterno>